var scope_0 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0273142e28a0bc32c05111763dedde08.js').default;
var scope_1 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2e9ec714e4a2215e75c42c62a1e485a7.js').default;
var scope_2 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a576be0c109a02b2081038da30e93f82.js').default;
var scope_3 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_4 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f98640040a6c17fbd566646f01aab184.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    